<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-content">
      <div class="box">
        <article class="media">
          <div class="media-content">
            <div class="content">
              <h3 class="title has-text-danger has-text-centered">#{{ inv }}({{ cha }})</h3>
              <div class="theme-table-container table-container center-column w-100">
                <table
                  class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped"
                >
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Paid Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="amnt of paidAmounts">
                      <td>{{ amnt.date }}</td>
                      <td>{{ getCurrency }}{{ amnt.amount | formatNumber }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <!-- <tr>
                      <th colspan="2" align="right">Total</th>
                      <th>{{ getCurrency }}{{ totalReceivables | formatNumber }}</th>
                    </tr>-->
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
  </div>
</template>

<script>
export default {
  props: ["inv", "cha", "paidAmounts"],
  computed: {
    isActive() {
      return this.$store.getters.getPaidAmountModalStatus;
    },
    // paidAmount() {
    //   return this.$store.getters.getPaidAmount;
    // },
    // totalReceivables() {
    //   //return Number(invoice.balance_due) - Number(invoice.paid_amount);
    // },
    getCurrency() {
      return this.$store.getters.getCurrentUser.info.price_plan.deposit_rate ==
        1
        ? "¥"
        : "$";
    },
  },
  created() {
    alert($props.inv);
  },
  methods: {
    closeModal() {
      this.$store.commit("setPaidAmountModalStatus", false);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Banking/PaidAmountModal.vue